import BookItem from "../common/bookItem";
// import { mouseEvent } from "../common/mouse_event";
// import AfilePageCount from "./afile_page_count";

//沒用了
export default class AfileChangePageNew extends BookItem {
    afilePageCount = null;
    nextButton = null;
    prevButton = null;
    numberButtons = [];
    nowFrame = null;
    constructor(el, target) {
        super(el, target);
        this.initialFrame = this.el.initialFrame - 1;
        this.totalFrame = parseInt(this.el.totalFrame);
        this.nowFrame = this.target.parent.currentFrame;
        this.nowPageNumber = (this.nowFrame - this.initialFrame) + 1;
        this.target.stage.tickOnUpdate = false;

        this.cubeBlank = this.target.children[0].regX * 2;
        this.blank = 20;
        this.targetLength;
        this.storeTargetX = this.target.x;
        //抓上下
        this.nextButton = this.target.getChildByName("next_btn");
        this.prevButton = this.target.getChildByName("prev_btn");


        //初始最多顯示6頁數字
        //抓數字按鈕(依預設數字從小到大抓)
        let i = 0;
        for (i = 0; i < 6; i++) {
            this.numberButtons.push(this.target.getChildByName("number_btn" + i));
        }
        //先移除child
        this.target.removeAllChildren();

        //好像沒用
        var graphics = new createjs.Graphics().beginFill("#ff0000").drawCircle(0, 0, 10);
        let point = new createjs.Shape(graphics);
        this.target.parent.addChild(point);


        //顯示座標(?)
        console.log("prevButton:", this.prevButton.getBounds());

        //設定上下頁預設x座標
        this.prevButton.x = 0;
        // this.nextButton.x = 400;

        // console.log("this.prevButton", this.prevButton);
        // console.log("this.nextButton", this.nextButton);
        // console.log("parent", this.nextButton.parent);


        //頁數組設置中
        console.log("constructor");
        //numberButtons預設存是6個但this.totalFrame大於6的話?
        for (i = 0; i < 6; i++) {
            if (i > this.totalFrame - 1) {
                this.numberButtons[i].visible = false;
                continue;
            }
            console.log("i", i, this.totalFrame);
            //塞新的text
            this.numberButtons[i].getChildByName("number_txt").text = i + 1;
            //預設座標
            // this.numberButtons[i].x = 58 + 58 * i;
            //初始影格
            this.numberButtons[i].gotoAndStop(0);
            //塞child回去
            this.target.addChild(this.numberButtons[i]);
            //添加點擊事件
            this.numberButtons[i].addEventListener("click", (e) => {
                this.trigger("num", e);
            })
        }
        //加prev num1~6 next
        this.target.addChild(this.prevButton);
        for (let numBtn = 0; numBtn < this.numberButtons.length; numBtn++) {
            this.target.addChild(this.numberButtons[numBtn]);
        }
        this.target.addChild(this.nextButton);

        for (let index = 0; index < this.target.children.length; index++) {
            this.target.children[index].x = index * (this.cubeBlank) + index * this.blank;
        }

        for (let index = 0; index < this.target.children.length; index++) {
            if (this.target.children[index].visible == false) {
                this.nextButton.x = this.target.children[index].x;
                this.targetLength = index * (this.cubeBlank) + index * this.blank;
                this.target.x += (this.target.children.length - index) * (this.cubeBlank) + (this.target.children.length - index) * this.blank
                console.log("this.targetLength", this.targetLength);
                break;
            }
        }
        console.log("this.target", this.target)
        console.log("this.target.parent", this.target.parent);
        console.log("this.target.x", this.target.x)


        this.prevButton.addEventListener("click", (e) => {
            console.log("this.prevButton+trigger");
            this.trigger("prev", e);
        })

        this.nextButton.addEventListener("click", (e) => {
            console.log("this.nextButton+trigger");
            this.trigger("next", e);
        })

        //update => Each time the update method is called, the stage will call tick unless tickOnUpdate is set to false, and then render the display list to the canvas.
        this.target.stage.update();
        //tickOnUpdate => If true, tick callbacks will be called on all display objects on the stage prior to rendering to the canvas.
        this.target.stage.tickOnUpdate = true;

        //當前頁面影格整理
        console.log("現在頁面影格位置:this.nowFrame", this.nowFrame);
        console.log("頁數數量:this.totalFrame", this.totalFrame);
        console.log("初始頁數影格:this.initialFrame", this.initialFrame);
        console.log("現在顯示頁數:", this.nowPageNumber);

        this.numberButtons[0].gotoAndStop(1);
    }

    init() {
        // console.log("this.target.parent.currentFrame", this.target.parent.currentFrame);

        //this.add_mouse_event();
        // console.log("this.itemControl.loader.stageWidth",this.itemControl.loader.stageWidth);

    }

    trigger(effect, e) {
        let numLevel;
        console.log("當前顯示頁數:", this.nowPageNumber, this.numberButtons);
        console.log("當前最大頁數:", this.totalFrame);

        switch (effect) {
            case "prev":
                console.log("prev");
                if (this.nowPageNumber == 1) {
                    return;
                }

                this.nowPageNumber -= 1;
                //被6除餘1
                if (this.nowPageNumber % 6 == 0) {
                    console.log("this.nowPageNumber / 6", this.nowPageNumber / 6);
                    numLevel = Math.floor(this.nowPageNumber / 6) - 1;
                    console.log("numLevel", numLevel);
                    //數字按鈕要切換數字跟右一改影格
                    for (let j = 0; j < 6; j++) {
                        //塞新的text
                        this.numberButtons[j].getChildByName("number_txt").text = 1 + j + 6 * numLevel;
                        //都看得見
                        this.numberButtons[j].visible = true;
                        //初始影格
                        this.numberButtons[j].gotoAndStop(0);
                    }

                    for (let index = 0; index < this.target.children.length; index++) {
                        this.target.children[index].x = index * (this.cubeBlank) + index * this.blank;
                    }
                    this.target.x = this.storeTargetX;

                    for (let index = 0; index < this.target.children.length; index++) {
                        if (this.target.children[index].visible == false) {
                            this.nextButton.x = this.target.children[index].x;
                            this.targetLength = index * (this.cubeBlank) + index * this.blank;
                            console.log("this.targetLength", this.targetLength);
                            break;
                        }
                    }

                    this.numberButtons[this.numberButtons.length - 1].gotoAndStop(1);
                } else {
                    for (let i = 0; i < this.numberButtons.length; i++) {
                        if (this.nowPageNumber % 6 == 0) {

                        }
                        if (i == (this.nowPageNumber % 6) - 1 || (this.nowPageNumber % 6 == 0 && i == this.numberButtons.length - 1)) {
                            this.numberButtons[i].gotoAndStop(1);
                        }
                        else {
                            this.numberButtons[i].gotoAndStop(0);
                        }
                    }
                }


                break;
            case "next":
                console.log("next");
                if (this.nowPageNumber == this.totalFrame) {
                    return;
                }

                this.nowPageNumber += 1;

                //被7整除
                if (this.nowPageNumber % 6 == 1) {
                    numLevel = Math.floor(this.nowPageNumber / 6);
                    console.log("numLevel", numLevel);
                    //數字按鈕要切換數字跟左一改影格
                    for (let j = 0; j < 6; j++) {
                        //塞新的text
                        this.numberButtons[j].getChildByName("number_txt").text = 1 + j + 6 * numLevel;
                        if (this.totalFrame < 1 + j + 6 * numLevel) {
                            this.numberButtons[j].visible = false;
                        }
                        //初始影格
                        this.numberButtons[j].gotoAndStop(0);
                    }
                    for (let index = 0; index < this.target.children.length; index++) {
                        this.target.children[index].x = index * (this.cubeBlank) + index * this.blank;
                    }

                    for (let index = 0; index < this.target.children.length; index++) {
                        if (this.target.children[index].visible == false) {
                            this.nextButton.x = this.target.children[index].x;
                            this.targetLength = index * (this.cubeBlank) + index * this.blank;
                            this.target.x += (this.target.children.length - index) * (this.cubeBlank) + (this.target.children.length - index) * this.blank;
                            console.log("this.targetLength", this.targetLength);
                            break;
                        }
                    }
                    this.numberButtons[0].gotoAndStop(1);
                } else {
                    for (let i = 0; i < this.numberButtons.length; i++) {
                        if (this.nowPageNumber % 6 == 0) {

                        }
                        if (i == (this.nowPageNumber % 6) - 1 || (this.nowPageNumber % 6 == 0 && i == this.numberButtons.length - 1)) {
                            this.numberButtons[i].gotoAndStop(1);
                        }
                        else {
                            this.numberButtons[i].gotoAndStop(0);
                        }
                    }
                }


                break;
            case "num":
                console.log("num");
                //全部數字按鈕都回初始影格
                this.numberButtons.forEach(element => {
                    element.gotoAndStop(0);
                });
                //指定物件切影格
                e.currentTarget.gotoAndStop(1);
                //名字
                this.nowPageNumber = e.currentTarget.number_txt.text;
                break;
        }

        console.log("this.target.parent", this.target.parent, this.target.parent.regX, this.target.parent.regY);

        console.log("this.target", this.target, this.target.regX, this.target.regY);

        console.log("this.target.children", this.target.children);
        // 2560 1440

        //svg
        this.itemControl.loader.loadBackground(this.initialFrame + this.nowPageNumber - 1);

        //frame
        this.target.parent.gotoAndStop(this.initialFrame + this.nowPageNumber - 1);

        this.itemControl.clearItems();
        this.itemControl.reInitStage();
        console.log("現在顯示頁數:", this.nowPageNumber);
        console.log("現在頁面影格位置", this.target.parent.currentFrame);
    }
}